import { render, staticRenderFns } from "./PDFCompra.vue?vue&type=template&id=7e889c04"
import script from "./PDFCompra.vue?vue&type=script&lang=js"
export * from "./PDFCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports